import { RootPaths } from "@src/appV2/App/paths";

export const FAILED_PAYOUT_BASE_PATH = "failed-payout";
export const FAILED_PAYOUT_FULL_PATH = `${RootPaths.APP_V2_HOME}/${FAILED_PAYOUT_BASE_PATH}`;
